import { AdjacentType, GraphType } from '@iotv/iotv-v3-types';
import { loadable } from 'react-lazily/loadable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TransactionFunctions, UserFunctions } from '../redux/actions/AppActionFunctions/AppActions';
import { ContextObjectType, ObjectViewType } from '../types';
const { DeviceManagementView } = loadable(() => import('../components/DeviceManagement/DeviceManagementView'));
const debug = process.env.REACT_APP_DEBUG && false;
const mapStateToProps = (state, ownProps) => {
    debug && console.log('DeviceManagement own props', { state, ownProps });
    const props = {
        userGroupRoles: state.AppReducer.userGroupRoles,
        userSelectedGroup: state.AppReducer.userSelectedGroup,
        user: state.AppReducer.user,
        contextObject: state.AppReducer.contextCustomer,
        constrainedParameters: {
            objectTypeId: 'Device',
            searchContextObject: state.AppReducer.contextCustomer,
            currentContextSearchMode: ContextObjectType.CUSTOMER,
            queryGraphType: GraphType.NODE,
            adjacencyType: AdjacentType.CHILD,
        },
        columnVisibilityReferences: {
            objectTypeId: 'Device',
            dataTableReference: 'DeviceRegisterContainer',
            viewType: ObjectViewType.List,
            externalColumnVisibility: undefined,
        },
    };
    return props;
};
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        init: (cognitoUser, userGroupRoles) => {
            debug && console.log('DeviceManagement Container requested init', ownProps);
        },
        userFunctions: bindActionCreators(UserFunctions, dispatch),
        transactionFunctions: bindActionCreators(TransactionFunctions, dispatch),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(DeviceManagementView);
